var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:[
    'btn',
    'mod-variant-'+_vm.variant,
    {
      'mod-disabled': _vm.disabled,
    }
  ],attrs:{"type":_vm.type,"disabled":_vm.disabled}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }